import { format, formatDistanceToNow } from "date-fns";
import { de, pl, fr, enGB } from "date-fns/locale";
import i18n from "src/i18n";

const localeMap = {
    de,
    pl,
    fr,
    enGB
  };

function getCurrentLocale() {
    const lang = i18n.language;
    return localeMap[lang] || de; // fallback to German if the language is not found
  }

// ----------------------------------------------------------------------
export function fDate(date) {
    return format(new Date(date), "dd MMMM yyyy", {locale: getCurrentLocale() });
}

export function fDateTime(date) {
    return format(new Date(date), "dd MMM yyyy HH:mm", {locale: getCurrentLocale() });
}

export function fDateTimeSuffix(date) {
    return format(new Date(date), "dd/MM/yyyy HH:mm", {locale: getCurrentLocale() });
}

export function fCountdownTimerFormat(date) {
    return format(new Date(date), "yyyy-MM-dd HH:mm:ss", {locale: getCurrentLocale() });
}

export function fToNow(date) {
    return formatDistanceToNow(new Date(date), {
        addSuffix: true,
       locale: getCurrentLocale(),
    });
}

export function isWinter() {
    const dt = new Date();
    const m = dt.getMonth();
    return m === 11 ? dt.getDate() >= 6 : m === 2 ? dt.getDate() < 21 : m < 2;
}
